
import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import LottieAnimation from '@/components/animations/LottieAnimation';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="flex flex-col justify-center items-center min-h-screen px-6 bg-[#FAF8F6] text-center">
      <div className="w-32 h-32 mb-6">
        <LottieAnimation 
          loop={true}
          autoplay={true}
          className="w-full h-full"
        />
      </div>
      <h1 className="text-5xl font-semibold text-[#5C322B] mb-4">✨ Coming Soon</h1>
      <p className="text-lg text-[#A55C52] max-w-xl mb-2">
        The page "{location.pathname}" is part of our next platform release.
      </p>
      <p className="text-base text-[#A55C52]/80 max-w-xl mb-6">
        We're actively building something beautiful here — stay tuned!
      </p>
      <Link 
        to="/" 
        className="text-[#CDA79D] hover:text-[#A55C52] transition-colors duration-300 underline font-medium"
      >
        ← Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
